class HotspotShowcaseProduct extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      hotspotButton: this.querySelector("[data-hotspot-icon]"),
      iconPlus: this.querySelector("[data-hotspot-icon-plus]"),
      iconClose: this.querySelector("[data-hotspot-icon-close]"),
      popover: document.getElementById("popover-link"),
    };

    this.elements.hotspotButton.addEventListener(
      "click",
      this.hotspotInitiate.bind(this),
    );
  }

  connectedCallback() {
    document.addEventListener("click", (event) => {
      if (
        !this.elements.popover.contains(event.target) &&
        !event.target.closest("hotspot-showcase")
      ) {
        this.toggleAllHotspot();
      }
    });
  }

  popoverPosition() {
    const button = this.elements.hotspotButton;
    const popover = this.elements.popover;
    if (!button || !popover) return;

    const relativeParent = popover.parentElement;
    const buttonRect = button.getBoundingClientRect();
    const parentRect = relativeParent.getBoundingClientRect();

    const top = buttonRect.bottom - parentRect.top + 8;
    let left = buttonRect.left - parentRect.left;

    popover.classList.add("invisible");
    popover.classList.remove("hidden");
    popover.classList.add("flex");

    const popoverWidth = popover.offsetWidth;

    popover.classList.add("hidden");
    popover.classList.remove("flex");
    popover.classList.remove("invisible");

    const maxLeft = relativeParent.offsetWidth - popoverWidth - 8;
    const minLeft = 8;
    left = Math.min(Math.max(left, minLeft), maxLeft);

    popover.style.top = `${top}px`;
    popover.style.left = `${left}px`;

    const productInformation = {
      imageHref: button.dataset.productImage,
      productTitle: button.dataset.productName,
      productLink: button.dataset.productLink,
      productPrice: button.dataset.productPrice,
    };

    const popoverImg = document.getElementById("popover-img");
    const popoverName = document.getElementById("popover-name");
    const popoverPrice = document.getElementById("popover-price");
    const popoverLink = document.getElementById("popover-link");

    const price = parseInt(productInformation.productPrice, 10) / 100;

    popoverImg.src = productInformation.imageHref;
    popoverName.textContent = productInformation.productTitle;
    popoverPrice.textContent = price.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
    popoverLink.href = productInformation.productLink;
  }

  hotspotInitiate() {
    const isSame = window.__activeHotspot === this.elements.hotspotButton;

    this.toggleAllHotspot();

    if (!isSame) {
      window.__activeHotspot = this.elements.hotspotButton;
      this.popoverPosition();
      this.elements.popover.classList.remove("hidden");
      this.elements.popover.classList.add("flex");
      this.elements.iconPlus.classList.add("hidden");
      this.elements.iconClose.classList.remove("hidden");
      console.log("Não é o mesmo");
    } else {
      console.log("é o mesmo");
      this.elements.popover.classList.add("hidden");
      this.elements.popover.classList.remove("flex");
      window.__activeHotspot = null;
    }
  }

  toggleAllHotspot() {
    const allHotspot = document.querySelectorAll("hotspot-showcase");

    allHotspot.forEach((el) => {
      const plus = el.querySelector("[data-hotspot-icon-plus]");
      const close = el.querySelector("[data-hotspot-icon-close]");

      if (plus && close) {
        plus.classList.remove("hidden");
        close.classList.add("hidden");
      }
    });

    this.elements.popover.classList.add("hidden");
    this.elements.popover.classList.remove("flex");
    window.__activeHotspot = null;
  }

  formatCurrency(value) {
    const reais = parseInt(value, 10) / 100;
    return reais.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }
}

customElements.define("hotspot-showcase", HotspotShowcaseProduct);
